// The step each radius falls back to when a theme leaves it unset.
export const defaultRadiusSteps = {
  modalAndLayerRadius: 'large',
  containerRadius: 'medium',
  formItemRadius: 'medium',
  buttonRadius: 'full'
} as const;

// Calculate the radius values for Modals and layers, Containers, Form items, and Buttons based on the provided theme configuration
// MODAL AND LAYER RADIUS
export const getModalAndLayerRadiusValue = (modalAndLayerRadius: 'none' | 'small' | 'medium' | 'large' | 'full' | undefined) => ({
  main: (() => {
    switch (modalAndLayerRadius ?? defaultRadiusSteps.modalAndLayerRadius) {
      case 'none':
        return 0;
      case 'small':
        return 12;
      case 'medium':
        return 16;
      case 'large':
        return 24;
      case 'full':
        return 40;
    }
  })(),
  mobile: (() => {
    switch (modalAndLayerRadius ?? defaultRadiusSteps.modalAndLayerRadius) {
      case 'none':
        return 0;
      case 'small':
        return 8;
      case 'medium':
        return 12;
      case 'large':
        return 20;
      case 'full':
        return 32;
    }
  })()
});

// TOOLTIP RADIUS
// Tooltips are layers, so they follow the modal and layer step, scaled down to
// a surface one line of 10px text tall. The default step keeps the design's 6px.
export const getTooltipRadiusValue = (modalAndLayerRadius: 'none' | 'small' | 'medium' | 'large' | 'full' | undefined) => {
  switch (modalAndLayerRadius ?? defaultRadiusSteps.modalAndLayerRadius) {
    case 'none':
      return 0;
    case 'small':
      return 3;
    case 'medium':
      return 4;
    case 'large':
      return 6;
    case 'full':
      return 999;
  }
};

// CONTAINER RADIUS
export const getContainerRadiusValue = (containerRadius: 'none' | 'small' | 'medium' | 'large' | 'full' | undefined) => ({
  main: (() => {
    switch (containerRadius ?? defaultRadiusSteps.containerRadius) {
      case 'none':
        return 0;
      case 'small':
        return 8;
      case 'medium':
        return 12;
      case 'large':
        return 20;
      case 'full':
        return 24;
    }
  })(),
  mobile: (() => {
    switch (containerRadius ?? defaultRadiusSteps.containerRadius) {
      case 'none':
        return 0;
      case 'small':
        return 6;
      case 'medium':
        return 8;
      case 'large':
        return 16;
      case 'full':
        return 20;
    }
  })()
});

// FORM ITEM RADIUS
export const getFormItemRadiusValue = (formItemRadius: 'none' | 'small' | 'medium' | 'large' | 'full' | undefined) => ({
  main: (() => {
    switch (formItemRadius ?? defaultRadiusSteps.formItemRadius) {
      case 'none':
        return 0;
      case 'small':
        return 4;
      case 'medium':
        return 8;
      case 'large':
        return 12;
      case 'full':
        return 999;
    }
  })(),
  mobile: (() => {
    switch (formItemRadius ?? defaultRadiusSteps.formItemRadius) {
      case 'none':
        return 0;
      case 'small':
        return 4;
      case 'medium':
        return 8;
      case 'large':
        return 12;
      case 'full':
        return 999;
    }
  })()
});

// BUTTON RADIUS
export const getButtonRadiusValue = (buttonRadius: 'none' | 'small' | 'medium' | 'large' | 'full' | undefined) => ({
  main: (() => {
    switch (buttonRadius ?? defaultRadiusSteps.buttonRadius) {
      case 'none':
        return 0;
      case 'small':
        return 4;
      case 'medium':
        return 8;
      case 'large':
        return 12;
      case 'full':
        return 999;
    }
  })(),
  mobile: (() => {
    switch (buttonRadius ?? defaultRadiusSteps.buttonRadius) {
      case 'none':
        return 0;
      case 'small':
        return 4;
      case 'medium':
        return 8;
      case 'large':
        return 12;
      case 'full':
        return 999;
    }
  })()
});